import createApiServices from "./createApiServices"
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const listReportCampaign = (payload, userName) => {
    return api.makeRequest({
        url: `report/campaignNhayMay?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportDataGoogleSheet = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportDataGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getDetailCallOut = (payload, userName) => {
    return api.makeRequest({
        url: `report/detailCallOut?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getProductivityAgent = (payload, userName) => {
    return api.makeRequest({
        url: `report/productivityAgent?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getProductivityAgentV2 = (payload, userName) => {
    return api.makeRequest({
        url: `report/productivityAgentV2?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getReportButtonClick = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportDetailDTMF?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportReportButtonGoogleSheet = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportDetailDTMFGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetDetailCallOut = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportGGSheetDetailCallOut?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetProductivityAgent = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportGGSheetProductivityAgent?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetProductivityAgentV2 = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportProductivityAgentV2GGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getReportBusiness = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportBusiness?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetReportBusiness = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportBusinessGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getReportSale = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportSalePerformance?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetReportSale = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportSalePerformanceGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getReportTech = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportTechnicalStatus?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportGeneralTechnicalStatus = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportGeneralTechnicalStatus?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportGeneralTechnicalStatusV2 = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportGeneralTechnicalStatusV2?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportGGSheetReportTech = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportTechnicalStatusGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportGeneralTechnicalStatusGGSheet = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportGeneralTechnicalStatusGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportGeneralTechnicalStatusGGSheetV2 = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportGeneralTechnicalStatusGGSheetV2?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportAccountantDataGGSheet = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportAccountantDataGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportLeadStatus = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportLeadStatus?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportReportLeadStatusGGSheet = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportLeadStatusGGSheet?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportLeadStatusByDay = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportLeadStatusByDay?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportLeadStatusBySalePersonName = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportLeadStatusBySalePersonName?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const reportCallDetailVoiceMail = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportVoiceMailCallDetail?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportCallDetailVoiceMail = (payload, userName) => {
    return api.makeRequest({
        url: `report/reportVoiceMailCallDetailCSV?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const exportCallLogCSV = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportCallLogCSV?userName=${userName}`,
        method: 'POST',
        data: payload,
        responseType: 'blob'
    })
}

export const exportFee6s1CSV = (payload, userName) => {
    return api.makeRequest({
        url: `report/exportFee6s1CSV?userName=${userName}`,
        method: 'POST',
        data: payload,
        responseType: 'blob'
    })
}
